import type { ComputedRef, InjectionKey } from "vue";
import type { ChoiceTileColumns, ChoiceTileLayout, ChoiceTileSize, ChoiceTileVariant } from "../ChoiceTile/choiceTile.types";
import type { RadioModelValue } from "../Radio/VRadio.types";

export interface VRadioTileGroupProps {
  /** Accessible name of the group when no visible heading names it. */
  ariaLabel?: string
  /** Id of the visible heading that names the group. Preferred over `ariaLabel`. */
  ariaLabelledby?: string
  /** Name shared by the radios; a unique one is generated when omitted. */
  name?: string
  /** See {@link ChoiceTileLayout}; a row tile needs about 240px, a stacked tile about 180px. */
  layout?: ChoiceTileLayout
  /** See {@link ChoiceTileColumns}. */
  columns?: ChoiceTileColumns
  /** How every tile of the group is laid out; see {@link ChoiceTileVariant}. Defaults to `row`. */
  variant?: ChoiceTileVariant
  /** Disables every tile of the group. */
  disabled?: boolean
  required?: boolean
}

export interface VRadioTileProps {
  value: RadioModelValue
  title: string
  subtitle?: string
  /** Disables this tile only; the group can disable all of them. */
  disabled?: boolean
  /** See {@link ChoiceTileSize}. */
  size?: ChoiceTileSize
  testId?: string
}

export interface RadioTileGroupContext {
  name: ComputedRef<string>
  modelValue: ComputedRef<RadioModelValue>
  disabled: ComputedRef<boolean>
  variant: ComputedRef<ChoiceTileVariant>
  select: (value: RadioModelValue) => void
}

export const RADIO_TILE_GROUP_KEY: InjectionKey<RadioTileGroupContext> = Symbol("radioTileGroup");
